import React,{Component} from 'react';
import {string} from 'prop-types'

import FooterData from '../../constants/footer';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import {Divider} from '@material-ui/core';
import Collapse from '@material-ui/core/Collapse';
import ListItemText from '@material-ui/core/ListItemText';
import CopyRight from './copyright';

import {rootUrl} from '../../helpers/ApplicationHelper';
import Logos from './logos';


class Footer extends Component{

  constructor(props){
    super(props);

    this.state = {};

    this.renderList = this.renderList.bind(this);
    this.renderListItems = this.renderListItems.bind(this);
  }

  static propTypes = {
    path:string
  };

  handleClick(itemName){
    this.setState({ [itemName]: !this.state[itemName]});

    let openedTabs = Object.keys(this.state);
    if (!openedTabs.length) return;

    openedTabs.forEach((name) => {
      if(name !== itemName)
        this.setState({[name]:false})
    });
  }

  renderList(tabs){
    return tabs.map((tab, idx) => {
      return (
          <List className={'tab-list'} key={idx}>
            {tab.items != null
                ? <React.Fragment>
                  <ListItem button onClick={this.handleClick.bind(this, tab.name)} className={'item'}>
                    <ListItemText primary={tab.name} className={'title'}/>
                    {this.state[tab.name]
                        ? <span className='arrow arrow-up'/>
                        : <span className='arrow arrow-down'/>}
                  </ListItem>
                  <Collapse key={idx} component='li'
                            in={this.state[tab.name]} timeout='auto'
                            unmountOnExit className={'sub-item-wrapper'}>
                    <List disablePadding className={'sub-item-list'}>
                      {tab.items.map((item, itemIdx) => {
                        return <ListItem button key={item.idx} component='a' className={'sub-item'} href={rootUrl(item.link)}>
                                 <ListItemText key={itemIdx} primary={item.name} className={'title ' + (item.name === 'faq' ? 'no-change' : '')}/>
                               </ListItem>
                      })}
                    </List>
                  </Collapse>

                </React.Fragment>

                : <ListItem button
                            onClick={this.handleClick.bind(this, tab.name)}
                            key={idx}>
                  <ListItemText primary={tab.name}/>
                </ListItem>
            }

            <Divider key={idx} absolute className={'divider'}/>
          </List>
      );
    });
  }

  renderListItems(tab){
    return tab.items.map((item,idx) => {
      return (
          <div key={idx}>
            {tab.items != null
                ? <div key={idx}>
                  <ListItem button key={idx} onClick={this.handleClick.bind(this, item.name)}>
                    <ListItemText primary={item.name} />
                    {this.state[item.name] ? 'expendMore' : 'expendLess'}
                  </ListItem>
                  <Collapse key={tab.items.id} component='li' in={this.state[item.name]} timeout='auto' unmountOnExit>
                    <List disablePadding >
                      {item.subitems.map((sitem) => {
                        return <ListItem button key={sitem.id} className={'sub-item-footer'}>
                          <ListItemText key={sitem.id} primary={sitem.name}/>
                        </ListItem>
                      })}
                    </List>
                  </Collapse>
                </div>
                :
                <ListItem button onClick={this.handleClick.bind(this, item.name)} key={item.id}>
                  <ListItemText primary={item.name}  />
                </ListItem> }

          </div>
      )
    });
  }

  render() {
    if(!this.props.path.includes('homepage')) return null;

    const {footerTabs:tabs, copyright, logos:companyLogos} = FooterData;
    const navigationMenu = this.renderList(tabs);

    return <footer className={'footer-homepage'}>
      <Logos rows={companyLogos}/>
      {navigationMenu}
      <CopyRight content={copyright}/>
    </footer>
  }
}

export default Footer;
